<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field
          flat
          hide-details
          solo
          rounded
          clearable
          background-color="grey lighten-3"
          label="Search tool name"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>

      <v-skeleton-loader
        type="actions"
        transition="fade-transition"
        v-if="loading"
      ></v-skeleton-loader>

      <template v-else>
        <v-btn class="ml-5" icon @click="showSearch = !showSearch">
          <img src="@/assets/icons/search.svg" alt height="17.7px" />
        </v-btn>
      </template>
    </v-app-bar>

    <div
      class="mx-4"
      id="job-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="100"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th colspan="2" class="text-left pa-0">Name</th>
            <th class="text-left">Price</th>
            <th class="text-left">Added date</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="job in jobs"
            :key="job.id"
            class="clickable"
            @click="
              $router.push({
                name: 'user.tool.details',
                params: { id: userUid, toolId: job.id }
              })
            "
          >
            <td colspan="2" class="py-5">
              <v-avatar size="20" class="mr-4">
                <v-img
                  :src="job.image || require('@/assets/icons/icon-image.svg')"
                ></v-img>
              </v-avatar>
              {{ job.name }}
            </td>
            <td class="py-5">$ {{ job.price }}/per day</td>
            <td class="py-5">{{ job.addedDate }}</td>
          </tr>

          <template v-if="loading">
            <tr v-for="index in 10" :key="index + '-skeleton'">
              <td class="py-3 pl-0" width="5%">
                <v-skeleton-loader
                  class="avatar-loading--36"
                  type="avatar"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiMagnify } from '@mdi/js'
import infiniteScroll from 'vue-infinite-scroll'
import debounce from 'lodash/debounce'
import User from '@/models/User'

export default {
  name: 'UsersJobPage',

  directives: {
    infiniteScroll
  },

  props: {
    user: {
      type: [User, Object]
    }
  },

  data() {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        search: mdiMagnify
      }
    }
  },

  created() {
    this.clearJobs()
    this.fetchJobs(1)
  },

  computed: {
    ...mapState({
      jobs: state => state.job.list,
      listMeta: state => state.job.listMeta
    }),

    userUid() {
      return this.user ? this.user.id : null
    },

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    ...mapActions({
      getJobs: 'job/getJobs'
    }),

    ...mapMutations({
      clearJobs: 'job/clearJobList'
    }),

    pageChanged(page) {
      this.fetchJobs(page)
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchJobs(this.listMeta.current_page + 1)
      }
    },

    search: debounce(function() {
      this.clearJobs()
      this.fetchJobs()
    }, 600),

    async fetchJobs(page = 1) {
      if (this.loading) return
      let params = { page }
      if (this.user) {
        params.user = this.user.id
      }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getJobs(params)
      this.loading = false
    }
  }
}
</script>
